import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckSquare, FileText, Crosshair, Utensils, Calendar, ListChecks } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <FileText className="w-6 h-6" data-id="element-233" />,
    title: 'El Manual Completo del Protocolo "Actuar es Ganar"',
    desc: 'PDF Digital con la doctrina completa de ejecución.'
  }, {
    icon: <Crosshair className="w-6 h-6" data-id="element-234" />,
    title: 'El Método Assassin de Finanzas',
    desc: 'Cómo identificar y recortar gastos para crear tu fondo de ataque.'
  }, {
    icon: <Utensils className="w-6 h-6" data-id="element-235" />,
    title: 'La Dieta del Operador',
    desc: 'Guía básica de nutrición para mantener la claridad mental y la energía alta.'
  }, {
    icon: <Calendar className="w-6 h-6" data-id="element-236" />,
    title: 'Calendario de Choque de 21 Días',
    desc: 'Tu hoja de ruta diaria sin espacio para dudas ni improvisación.'
  }, {
    icon: <ListChecks className="w-6 h-6" data-id="element-237" />,
    title: 'Checklist de Micro-Acciones',
    desc: 'El filtro táctico para saber qué es importante y qué es solo ruido.'
  }];
  return <section className="py-24 bg-tactical-panel border-b border-tactical-border" data-id="element-238">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-239">
        <FadeIn data-id="element-240">
          <div className="flex flex-col md:flex-row gap-12 items-start" data-id="element-241">
            {/* Header / Dossier Cover */}
            <div className="md:w-1/3 sticky top-8" data-id="element-242">
              <h2 className="text-4xl font-bold uppercase mb-4" data-id="element-243">
                Dossier de <br data-id="element-244" />
                <span className="text-tactical-accent" data-id="element-245">Operaciones</span>
              </h2>
              <p className="text-zinc-400 mb-8" data-id="element-246">
                Todo lo que necesitas para ejecutar el protocolo sin
                distracciones. Formato digital, acceso inmediato.
              </p>
              <div className="w-full aspect-[3/4] bg-tactical-dark border-2 border-zinc-800 p-6 relative flex flex-col justify-between hidden md:flex" data-id="element-247">
                <div className="font-mono text-xs text-zinc-600 uppercase" data-id="element-248">
                  Top Secret // Eyes Only
                </div>
                <div className="text-center" data-id="element-249">
                  <div className="w-16 h-16 mx-auto border-4 border-tactical-accent rounded-full flex items-center justify-center mb-4" data-id="element-250">
                    <CheckSquare className="w-8 h-8 text-tactical-accent" data-id="element-251" />
                  </div>
                  <div className="font-oswald text-xl uppercase tracking-widest text-zinc-300" data-id="element-252">
                    Kit Completo
                  </div>
                </div>
                <div className="font-mono text-xs text-zinc-600 uppercase text-right" data-id="element-253">
                  ID: 098-ACT
                </div>
              </div>
            </div>

            {/* List */}
            <div className="md:w-2/3 space-y-4" data-id="element-254">
              {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-255">
                  <div className="bg-tactical-dark border border-zinc-800 p-6 flex gap-4 hover:border-tactical-accent/50 transition-colors group" data-id="element-256">
                    <div className="mt-1 text-tactical-accent group-hover:scale-110 transition-transform" data-id="element-257">
                      {item.icon}
                    </div>
                    <div data-id="element-258">
                      <h3 className="font-oswald text-xl uppercase tracking-wide text-zinc-100 mb-1" data-id="element-259">
                        {item.title}
                      </h3>
                      <p className="text-zinc-400 text-sm" data-id="element-260">{item.desc}</p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}